import { SHIFTTYPE_COMPANY } from "./types";

import ActionHelper from "../helpers/ActionHelper";

export const createShiftTypeCompany = (shiftTypeId, form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    `/shifttype/${shiftTypeId}/company`,
    form,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_REQUEST,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_SUCCESS,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_FAIL,
    dispatch,
  );
};

export const getShiftTypeCompanies = (shiftTypeId) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/shifttype/${shiftTypeId}/company`,
    null,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_REQUEST,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_SUCCESS,
    SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_FAIL,
    dispatch,
  );
};

export const getShiftTypeCompany =
  (shiftTypeId, companyEmail) => (dispatch) => {
    return ActionHelper.requestServer(
      "GET",
      `/shifttype/${shiftTypeId}/company/${companyEmail}`,
      null,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_REQUEST,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SUCCESS,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_FAIL,
      dispatch,
    );
  };

export const updateShiftTypeCompany =
  (shiftTypeId, companyEmail, form) => (dispatch) => {
    return ActionHelper.requestServer(
      "PUT",
      `/shifttype/${shiftTypeId}/company/${companyEmail}`,
      form,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_REQUEST,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_SUCCESS,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_FAIL,
      dispatch,
    );
  };

export const deleteShiftTypeCompany =
  (shiftTypeId, companyEmail) => (dispatch) => {
    return ActionHelper.requestServer(
      "DELETE",
      `/shifttype/${shiftTypeId}/company/${companyEmail}`,
      null,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_REQUEST,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_SUCCESS,
      SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_FAIL,
      dispatch,
    );
  };



// WEBPACK FOOTER //
// ./src/actions/shiftTypeCompanyActions.js